import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Params } from '@angular/router';
import { RouterReducerState } from '@ngrx/router-store';
import { RouteData, RouteParams } from '@icilalune/types';

export const selectRouter = createFeatureSelector<RouterReducerState>('router');

export const selectRouteUrl = createSelector(selectRouter, (router) => {
  return router?.state?.url;
});

export const selectRouteNestedParams = createSelector(
  selectRouter,
  (router) => {
    let currentRoute = router?.state?.root;
    let params: Params = {};
    while (currentRoute?.firstChild) {
      currentRoute = currentRoute.firstChild;
      params = {
        ...params,
        ...currentRoute.params,
      };
    }
    return params as RouteParams;
  }
);

export const selectRouteNestedData = createSelector(selectRouter, (router) => {
  let currentRoute = router?.state?.root;
  let data: any = {};
  while (currentRoute?.firstChild) {
    currentRoute = currentRoute.firstChild;
    data = {
      ...data,
      ...currentRoute.data,
      queries: {
        ...data.queries,
        ...currentRoute.data?.['queries'],
      },
    };
  }
  return data as RouteData;
});

export const selectRouteNestedQueryParams = createSelector(
  selectRouter,
  (router) => {
    let currentRoute = router?.state?.root;
    let queryParams: any = {};
    while (currentRoute?.firstChild) {
      currentRoute = currentRoute.firstChild;
      queryParams = {
        ...queryParams,
        ...currentRoute.queryParams,
      };
    }
    return queryParams;
  }
);

export const selectFragment = createSelector(selectRouter, (router) => {
  return router?.state?.root?.fragment;
});

export const selectRouteNewsId = createSelector(
  selectRouteNestedParams,
  (params: RouteParams) => {
    return params?.newsId;
  }
);

export const selectRouteBlogId = createSelector(
  selectRouteNestedParams,
  (params: RouteParams) => {
    return params?.blogId;
  }
);

export const selectRouteClientId = createSelector(
  selectRouteNestedParams,
  (params: RouteParams) => {
    return params?.clientId;
  }
);

export const selectRouteServiceId = createSelector(
  selectRouteNestedParams,
  (params: RouteParams) => {
    return params?.serviceId;
  }
);

export const selectRoutePageId = createSelector(
  selectRouteNestedParams,
  selectFragment,
  (params: RouteParams, fragment: string | null) => {
    return params?.pageId || fragment;
  }
);

export const selectRouteProjectId = createSelector(
  selectRouteNestedParams,
  (params: RouteParams) => {
    return params?.projectId;
  }
);

export const selectRouteHomeNodeId = createSelector(
  selectRouteNestedParams,
  (params: RouteParams) => {
    return params?.homeNodeId;
  }
);

export const selectRouteSolutionId = createSelector(
  selectRouteNestedParams,
  (params: RouteParams) => {
    return params?.solutionId;
  }
);

export const selectRouteLanguage = createSelector(
  selectRouteNestedParams,
  (params: RouteParams) => {
    return params?.language;
  }
);

export const selectIsHome = createSelector(
  selectRouteNestedData,
  (data: RouteData) => {
    return data.isHome === true;
  }
);

export const selectIsSettings = createSelector(
  selectRouteNestedData,
  (data: RouteData) => {
    return data.isSettings;
  }
);

export const selectRouteContext = createSelector(
  selectRouteNestedData,
  (data: RouteData) => {
    return data.context;
  }
);
